import React, { useEffect } from "react";
import "./HomeContent.css";
import { Fade } from "react-awesome-reveal";

const HomeContent = () => {
  useEffect(() => {
    const body = document.querySelector("#root");
    if (body) {
      body.scrollIntoView({
        behavior: "smooth",
      });
    }
  }, []);

  return (
    <section className="container my-5 pd_hoc_section">
      <div className="row align-items-center">
        {/* Left Content */}
        <div className="col-12 col-lg-6 pd_hoc_content">
          <Fade direction="right" duration={3000}>
            <p className="pd_hoc_paragraph">
              Whether you are a beginner looking for fun, a fitness enthusiast
              pushing limits, or a parent encouraging your child’s talents, our
              programs are designed to suit all ages. With expert trainers, a
              friendly environment, and a focus on personal growth, we ensure
              every student feels motivated and empowered.
            </p>
          </Fade>
        </div>

        {/* Right Image */}
        <div className="col-12 col-lg-6 pd_hoc_image_wrapper">
          <img
            className="pd_hoc_image"
            src="https://i.pinimg.com/736x/a4/40/55/a440550b940057627cef5eed2e8385c3.jpg"
            alt="Fitness Program"
          />
        </div>
      </div>
    </section>
  );
};

export default HomeContent;
